import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Preloader.module.css";
import logoImage from "../assets/logo.png";

const PreloaderContext = createContext();
export const usePreloader = () => useContext(PreloaderContext);

export const PreloaderProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Tracks if the site has been opened for the first time in this session
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const enabledPaths = useMemo(
    () => [
      "/",
      "/about",
      "/locations/mafi",
      "/locations/hawassa",
      "/locations/bherawi",
      "/roastery",
      "/menu",
      "/products",
      "/contact",
      "/privacy",
      "/terms",
      "/sales-policy",
      "/legal",
    ],
    []
  );

  // Instant cover if refreshing on a whitelisted page
  const [loading, setLoading] = useState(
    enabledPaths.includes(location.pathname)
  );

  useEffect(() => {
    const isWhitelisted = enabledPaths.includes(location.pathname);

    if (isWhitelisted) {
      setLoading(true);

      /**
       * 🕒 CONDITIONAL TIMING:
       * Initial open: 2000ms (2s) for video buffering.
       * Internal Navigation: 1000ms (1s) for quick transitions.
       */
      const delay = isFirstLoad ? 2000 : 1000;

      const timer = setTimeout(() => {
        setLoading(false);
        // Toggle flag so subsequent pages load faster
        if (isFirstLoad) setIsFirstLoad(false);
      }, delay);

      return () => clearTimeout(timer);
    } else {
      setLoading(false);
    }
  }, [location.pathname, enabledPaths, isFirstLoad]);

  const triggerTransition = (path) => {
    const isWhitelisted = enabledPaths.includes(path);
    if (isWhitelisted) {
      setLoading(true);
      setTimeout(() => {
        navigate(path);
      }, 200);
    } else {
      navigate(path);
    }
  };

  const setVideoLoaded = () => {};
  const setIsPageReady = () => {};

  return (
    <PreloaderContext.Provider
      value={{ triggerTransition, setVideoLoaded, setIsPageReady }}
    >
      {children}
      <div className={`${styles.preloader} ${loading ? styles.active : ""}`}>
        <div className={styles.content}>
          <img src={logoImage} alt="Dukamo Logo" className={styles.logo} />
          <div className={styles.line}></div>
        </div>
      </div>
    </PreloaderContext.Provider>
  );
};
